import { useTranslation } from "react-i18next";
import { useFetch } from "../../../hooks/useFecth";
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { AppContext } from "../../../context/AppContext";
import { Box, Button, FormControl, InputLabel, MenuItem, Modal, Select, Typography } from "@mui/material";

import HandlerApp from "../../../utils/handlerApp";

const ReportSAS = () => {
    const endpoint = "/administration/locations";
    const parent = "Reports";
    const [t] = useTranslation("global");
    const title = t("reports.SAS report");
    const api = useFetch();
    const handlerApp = HandlerApp();
    const { app } = useContext(AppContext);

    const [permissions, setPermissions] = useState([]);
    const [menus, setMenus] = useState([]);
    const [machines, setMachines] = useState([]);
    const [machine, setMachine] = useState("");
    const [errors, setErros] = useState({
        cashin_date_init: false,
        cashin_date_end: false,
        machine: false,
    });

    const [openModal, setOpenModal] = useState(false);
    const [resultData, setResultData] = useState(null);
    const [selectedPoll, setSelectedPoll] = useState(null);

    const polls = [
        // { code: "0x10", name: "Canceled credits" },
        { code: "0x11", name: "Total Coin In" },
        { code: "0x12", name: "Total Coin Out" },
        { code: "0x13", name: "Total Drop" },
        { code: "0x14", name: "Total Jackpot" },
        { code: "0x15", name: "Games Played" },
        { code: "0x16", name: "Games Won" },
        { code: "0x17", name: "Games Lost" },
        { code: "0x1A", name: "Current Credits" },
        { code: "0x19", name: "Meters" },
        { code: "0x1E", name: "Bill Meters" },
        { code: "0x1F", name: "Paytable ID / Denomination " },
        { code: "0x54", name: "SAS version / Serial Machine" },
        { code: "0x51", name: "Number of Games Implemented" },
        { code: "0x55", name: "Selected Game Numbers" },
        { code: "0x56", name: "Enabled Game Numbers" },
        // { code: "0x1B", name: "Send handpay information" },
        // { code: "0x94", name: "Send 94" },
        // { code: "0x3D", name: "Send 3D" }, test

    ];

    const DENOMINATION_MAP = {
        0x01: { value: 0.01, label: "$0.01" },
        0x02: { value: 0.05, label: "$0.05" },
        0x03: { value: 0.10, label: "$0.10" },
        0x04: { value: 0.25, label: "$0.25" },
        0x05: { value: 0.50, label: "$0.50" },
        0x06: { value: 1.00, label: "$1.00" },
        0x07: { value: 5.00, label: "$5.00" },
        0x08: { value: 10.00, label: "$10.00" },
        0x09: { value: 20.00, label: "$20.00" },
        0x0A: { value: 100.00, label: "$100.00" },
        0x0B: { value: 0.20, label: "$0.20" },
        0x0C: { value: 2.00, label: "$2.00" },
        0x0D: { value: 2.50, label: "$2.50" },
        0x0E: { value: 25.00, label: "$25.00" },
        0x0F: { value: 50.00, label: "$50.00" },
        0x10: { value: 200.00, label: "$200.00" },
        0x11: { value: 250.00, label: "$250.00" },
        0x12: { value: 500.00, label: "$500.00" },
        0x13: { value: 1000.00, label: "$1000.00" },
        0x14: { value: 2000.00, label: "$2000.00" },
        0x15: { value: 2500.00, label: "$2500.00" },
        0x16: { value: 5000.00, label: "$5000.00" },
        0x17: { value: 0.02, label: "$0.02" },
        0x18: { value: 0.03, label: "$0.03" },
        0x19: { value: 0.15, label: "$0.15" },
        0x1A: { value: 0.40, label: "$0.40" },
        0x1B: { value: 0.005, label: "$0.005" },
        0x1C: { value: 0.0025, label: "$0.0025" },
        0x1D: { value: 0.002, label: "$0.002" },
        0x1E: { value: 0.001, label: "$0.001" },
        0x1F: { value: 0.0005, label: "$0.0005" },
    };


    useEffect(() => {
        setMenus(app.menus[parent]);
        setPermissions(app.permissions[endpoint]);
    }, [app]);

    useEffect(() => {
        sendRequest();
    }, []);

    const sendRequest = () => {
        handlerApp.setLoader(true);
        api.get(endpoint, { action: "getParamsUpdateMachines" })
            .then((response) => {
                if (response.success) {
                    setMachines(handlerApp.getResultFromObject(response.data, "machines"));
                } else {
                    handlerApp.handlerResponse(response);
                }
                handlerApp.setLoader(false);
            })
            .catch((error) => {
                handlerApp.showError(t(error.message));
                handlerApp.setLoader(false);
            });
    };

    // ---------- helpers ----------
    const bcdToInt = (bytesArr) => {
        // bytesArr = ["00","00","00","18"] => "00000018" => 18
        const s = bytesArr.map(b => b.padStart(2, "0")).join("");
        const clean = s.replace(/^0+/, "") || "0";
        return Number(clean);
    };

    const hexBytes = (hexString) => hexString.trim().split(/\s+/).map(b => b.replace(/^0x/i, "").toUpperCase());


    const formatSASResponse = (hexString) => {
        if (!hexString) return "0.00";
        const bytes = hexBytes(hexString);
        if (bytes.every((b) => b === "00")) return "0.00";
        if (bytes.length === 2) {
            const integerPart = bytes[0].replace(/^0+/, "") || "0";
            return `${integerPart}.${bytes[1]}`;
        }
        if (bytes.length === 3) {
            const integerPart = (bytes[0] + bytes[1]).replace(/^0+/, "") || "0";
            return `${integerPart}.${bytes[2]}`;
        }
        if (bytes.length === 4) {
            const integerPart = (bytes[0] + bytes[1] + bytes[2]).replace(/^0+/, "") || "0";
            return `${integerPart}.${bytes[3]}`;
        }
        return bytes.join(" ");
    };

    const parseLongPoll = {
        // 0x15 – Games Played (4-byte BCD entero)
        "0x15": (data) => {
            const n = bcdToInt(hexBytes(data));
            return { GamesPlayed: n };
        },

        // 0x16 – Games Won (4-byte BCD entero)
        "0x16": (data) => {
            const n = bcdToInt(hexBytes(data));
            return { GamesWon: n };
        },

        // 0x17 – Games Lost (4-byte BCD entero)
        "0x17": (data) => {
            const n = bcdToInt(hexBytes(data));
            return { GamesLost: n };
        },
        // 0x1F – Gaming Machine ID & Info (estructura en manual)
        "0x1F": (data) => {
            const bytes = hexBytes(data);
            const toAscii = (arr) => String.fromCharCode(...arr.map(b => parseInt(b, 16))).replace(/\0/g, "");

            const denomCode = parseInt(bytes[5], 16);
            const denomInfo = DENOMINATION_MAP[denomCode];

            const maxBetCredits = parseInt(bytes[6], 16);
            const maxBetValue = denomInfo
                ? (maxBetCredits * denomInfo.value).toFixed(2)
                : null;

            const basePercentRaw = toAscii(bytes.slice(16, 20));
            const basePercentValue = Number(basePercentRaw) / 100;

            return {
                GameID: toAscii(bytes.slice(0, 2)),
                AdditionalID: toAscii(bytes.slice(2, 5)),
                Denomination: denomInfo
                    ? `${denomInfo.label} (code ${denomCode.toString(16).toUpperCase().padStart(2, "0")})`
                    : `Unknown (code ${denomCode})`,
                MaxBet: `${maxBetCredits} credits${maxBetValue ? ` ($${maxBetValue})` : ""}`,
                PaytableID: toAscii(bytes.slice(10, 16)),
                BasePercent: isNaN(basePercentValue)
                    ? basePercentRaw
                    : `${basePercentValue.toFixed(2)}%`,
            };
        },

        // 0x19 – Meters (asumimos bloques de 4 BCD; si hay 5, mapeamos a comunes)
        "0x19": (data) => {
            const bytes = hexBytes(data);
            const blocks = [];
            for (let i = 0; i < bytes.length; i += 4) {
                const raw = bytes.slice(i, i + 4).map(b => b.padStart(2, "0")).join("");
                const clean = raw.replace(/^0+/, "") || "0";
                // insertar punto decimal antes de los últimos 2 dígitos

                if (i + 4 >= bytes.length) {
                    blocks.push(parseInt(clean, 10)); // entero
                } else {
                    // para los demás: 2 decimales implícitos
                    const withDecimal =
                        clean.length > 2
                            ? `${clean.slice(0, -2)}.${clean.slice(-2)}`
                            : `0.${clean.padStart(2, "0")}`;
                    blocks.push(parseFloat(withDecimal));
                }
            }

            if (blocks.length === 5) {
                const [coinIn, coinOut, drop, jackpot, gamesPlayed] = blocks;
                return {
                    CoinIn: coinIn.toFixed(2),
                    CoinOut: coinOut.toFixed(2),
                    Drop: drop.toFixed(2),
                    Jackpot: jackpot.toFixed(2),
                    GamesPlayed: gamesPlayed,
                };
            }

            const obj = {};
            blocks.forEach((v, i) => {
                obj[`Meter${i + 1}`] = v.toFixed(2);
            });
            return obj;
        },

        // 0x1E – Bill Meters (bloques de 4 BCD: $1, $2, $5, $10, $20, $50, $100 … según vengan)
        "0x1E": (data) => {
            const bytes = hexBytes(data);
            const denoms = [1, 5, 10, 20, 50, 100]; // mapa estándar; usamos tantos como lleguen
            const result = {};
            let di = 0;
            for (let i = 0; i < bytes.length; i += 4, di++) {
                const count = bcdToInt(bytes.slice(i, i + 4));
                const label = denoms[di] != null ? `$${denoms[di]}` : `Bill${di + 1}`;
                result[label] = count;
            }
            return result;
        },

        // 0x51 – Number of games implemented (2 BCD) 
        "0x51": (data) => {
            const n = bcdToInt(hexBytes(data));
            return { ImplementedGames: n };
        },

        // 0x54 – SAS version (3 ASCII) & serial (ASCII variable)
        "0x54": (data) => {
            const bytes = hexBytes(data);
            const toAscii = (arr) => String.fromCharCode(...arr.map(b => parseInt(b, 16))).replace(/\0/g, "");
            const version = toAscii(bytes.slice(1, 4)); // [len][ver3][ver2][ver1]
            const serial = toAscii(bytes.slice(4));
            return { SASVersion: version, Serial: serial };
        },

        // 0x55 – Selected game number (2 BCD)
        "0x55": (data) => {
            const n = bcdToInt(hexBytes(data));
            return { SelectedGame: n };
        },

        // 0x56 – Enabled game numbers (len, count, luego N juegos de 2 BCD)
        "0x56": (data) => {
            const bytes = hexBytes(data);
            const count = parseInt(bytes[1], 16);
            const games = [];
            for (let i = 0; i < count; i++) {
                const start = 2 + i * 2;
                games.push(bcdToInt(bytes.slice(start, start + 2)));
            }
            return { EnabledGames: games };
        },
    };

    const handleSendPoll = (pollCode) => {

        const poll = polls.find((p) => p.code === pollCode);
        setSelectedPoll(poll);
        handlerApp.setLoader(true);

        api.get('reports/sas/' + machine.code + '/' + pollCode)
            .then((response) => {
                handlerApp.setLoader(false);
                if (response.success && response.data && response.data.length > 0) {
                    const res = response.data[0];
                    setResultData({
                        machine_id: res.machine_id,
                        response: res.response,
                        date: res.date,
                    });
                    setOpenModal(true);
                } else {
                    handlerApp.handlerResponse(response);
                }
            })
            .catch((error) => {
                handlerApp.setLoader(false);
                handlerApp.showError(t(error.message));
            });
    };

    const hasParser = (pollCode) => Boolean(parseLongPoll[pollCode]);
    const translateResponse = (pollCode, data) => hasParser(pollCode) ? parseLongPoll[pollCode](data) : formatSASResponse(data);


    const renderResponse = (pollCode, data) => {
        const parsed = translateResponse(pollCode, data);

        // si es objeto (parser dedicado) -> lista sin "Valor:"
        if (typeof parsed === "object" && parsed !== null) {
            return (
                <Box mt={1}>
                    {Object.entries(parsed).map(([key, val]) => (
                        <Typography key={key}><strong>{key}:</strong> {Array.isArray(val) ? val.join(", ") : val}</Typography>
                    ))}
                </Box>
            );
        }
        return (
            <Typography mt={1}>
                <strong>Valor:</strong> {parsed}
            </Typography>
        );
    };

    return (
        <div className="app container">
            {/* <!-- titulo --> */}
            <div className="d-flex justify-content-between">
                <section className="section-title-page">
                    <h3 className="title-page">{title}</h3>
                    <p className="light">{t("reports.SAS description")}</p>
                </section>
            </div>

            {/* <!-- Menu interno --> */}
            <nav className="child-menu">
                {menus?.map((item) => (
                    <NavLink
                        key={item.menu_children}
                        to={"/" + item.menu_children_action}
                        activeclassname="active"
                    >
                        {item.menu_children}
                    </NavLink>
                ))}
            </nav>

            <section className="filters">
                <div className="row justify-content-md-left px-4 mb-3">
                    <div className="col-md-4">

                        <FormControl className="w-100 bg-white" size="small">
                            <InputLabel id="machine-label">{t("reports.machines")}</InputLabel>
                            <Select
                                labelId="machine-label"
                                value={machine?.code || ""}
                                label={t("reports.machines")}
                                onChange={(e) => {
                                    setErros({ ...errors, machine: !e.target.value });
                                    const selectedCode = e.target.value;
                                    const selected = machines.find((m) => m.code === selectedCode);
                                    setMachine(selected);
                                }}
                            >
                                <MenuItem value="">
                                    <em>...</em>
                                </MenuItem>
                                {machines.map((m) => (
                                    <MenuItem key={m.code} value={m.code}>
                                        {m.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {errors.machine && (
                            <small className="text-danger">{t("errors.required")}</small>
                        )}
                    </div>
                </div>

                {machine && machine !== "All" && (
                    <div className="row justify-content-md-center">
                        <div className="row justify-content-md-center mb-3">
                            <div className="d-flex flex-wrap gap-2">
                                {polls.map((poll) => (
                                    <button
                                        key={poll.code}
                                        className="btn btn-outline-secondary"
                                        onClick={() => handleSendPoll(poll.code)}
                                    >
                                        {poll.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                )
                }
            </section >
            <Modal
                open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        borderRadius: 3,
                        boxShadow: 24,
                        p: 4,
                        width: 400,
                    }}
                >
                    <Typography id="modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                        📡 {selectedPoll ? selectedPoll.name : "Resultado del Poll SAS"}
                    </Typography>

                    {resultData ? (
                        <>
                            <Typography><strong>Máquina:</strong> {resultData.machine_id}</Typography>
                            {renderResponse(selectedPoll?.code, resultData.response)}
                            <Typography><strong>Hora:</strong> {new Date(resultData.date).toLocaleString()}</Typography>
                        </>
                    ) : (
                        <Typography>No hay datos disponibles.</Typography>
                    )}

                    <Box textAlign="right" mt={3}>
                        <Button variant="contained" color="primary" onClick={() => setOpenModal(false)}>
                            Cerrar
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </div >
    );
};

export default ReportSAS;
